import { Component, OnInit } from '@angular/core';
//import {Control} from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Compiler, NgZone } from '@angular/core';
import {FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';
import {SelectItem, DataTableModule, ButtonModule, DialogModule, InputTextModule, MessagesModule, Message, CalendarModule, InputTextareaModule, FileUploadModule, ConfirmationService, BlockUIModule} from 'primeng/primeng';
import {  ProfileDataService, SeedDataService} from '../../Services/index';
import { LOVTypes, LOV, LOVTypeVal, LOVVal, LOVAccessType } from '../../Models/seed.data';
import { Page } from '../../Models/pages';


@Component({
    //moduleId: module.id,
    templateUrl: './UserDetails.html'
})


export class UserDetailsComponent implements OnInit {

    workLocation: SelectItem[];
    public profileDetails: any;
    public detail: any;
    disabled: boolean = true;
    editProfileDialog: boolean = false;
    errorMsgs: Message[] = [];
    UserId: string;
    userImg: string;
    bloodGroup: SelectItem[];
    hobbieslist: SelectItem[];
    passingYear: SelectItem[];
    zodiacSign: SelectItem[];
    Validplace: boolean;
    ValidDependentName: boolean;
    ValidDependentDateOfBirth: boolean;
    ValidDate: boolean;
    ValidDOB: boolean;
    ValidPersonalEmailID: boolean;
    ValidMobileNumber: boolean;
    ValidboardOrUniversityName: boolean;
    ValidSpecializationName: boolean;
    ValidboardName10th: boolean;
    ValidschoolOrCollegeName: boolean;
    ValidPANNo: boolean;
    ValidHobbies: boolean;
    ValidPreviousCompanyName: boolean;
    ValidschoolOrCollegeName12th: boolean;
    ValidJobTitleName: boolean;
    PageIsvalid: boolean;
    msgs: Message[] = [];
    userform: FormGroup;
    submitted: boolean = false;
    cdob: string;
    dependentRelationships: SelectItem[];
    public experinceDetails: any;
    public dependentDetails: any;
    Validpercentage10th: boolean;
    DeleteProfileImage: boolean;
    dataSources: SelectItem[];
    selectedDataSource: string;
    ValidAnniversaryDate: boolean;
    ValidEmergencyMobileNumber: boolean;
    ValidAdharNumber: boolean;
    uploadedFiles: any[] = [];
    uploadedUploadFiles: any[] = [];
	maritalStatusList: any = null;
    SingleMaritalStatusName = '';
    SingleMaritalStatusID = '';
    DisableAnniversaryDate = false;
    DisableCelebratedDateOfBirth = false;
    ValidpostGraduationPercentage: boolean;
    ValidgraduationPercentage: boolean;
    Validpercentage12th: boolean;
    maxDate: Date;
    DisableUAN = false;
    DisableESIC = false;
    DisableadharNumber = false;

    PageIsvalidSpecialization1Oth: boolean;
    PageIsvalidpercentage12th: boolean;
    PageIsvalidpostGraduationPercentage: boolean;
    PageIsvalidgraduationPercentage: boolean;
    loading: boolean = false;
    refdate: any;
    Specialization1Oth: any;
    Specialization12th: any;
    SpecializationGradution: any;
    SpecializationPostGradution: any;

    constructor(private profiledataservice: ProfileDataService, private seedDataService: SeedDataService, private fb: FormBuilder, private _compiler: Compiler, private zone: NgZone, private confirmationService: ConfirmationService, private route: ActivatedRoute,
        private router: Router) {
        //this.userDetails = [];
        this.profileDetails = [];
        this.bloodGroup = [];
        this.dependentDetails = [];
        this.Specialization1Oth = [];
        this.Specialization12th = [];
        this.SpecializationGradution = [];
        this.SpecializationPostGradution = [];
        this.experinceDetails = [];
    }

    ngOnInit() {        

        this.seedDataService.getLOVByTypeName("BloodGroup").subscribe((bg: SelectItem[]) => {
            let data = this.renamePropertyNames(JSON.stringify(bg), "Select Blood Group");
            //console.log(data);
            this.bloodGroup = data;            
        });
        this.seedDataService.getLOVByTypeName("MaritalStatus").subscribe((maritalStatuslist: SelectItem[]) => {
            let data = this.renamePropertyNames(JSON.stringify(maritalStatuslist), "Select");
            this.maritalStatusList = data;
        });
        this.seedDataService.getLOVByTypeName("ZodiacSigns").subscribe((zodiacSign: SelectItem[]) => {
            let data = this.renamePropertyNames(JSON.stringify(zodiacSign), "");
            this.zodiacSign = data;
        });
        this.seedDataService.getLOVByTypeName("PassingYear").subscribe((passingYear: SelectItem[]) => {
            let data = this.renamePropertyNames(JSON.stringify(passingYear), "");
            this.passingYear = data;
        });
        this.seedDataService.getLOVByTypeName("DependentRelationship").subscribe((dependentRelationships: SelectItem[]) => {
            let data = this.renamePropertyNames(JSON.stringify(dependentRelationships), "");
            this.dependentRelationships = data;
            console.log("this.dependentRelationships", this.dependentRelationships);
        });
        if (this.route.snapshot.params['UserId'] != null && this.route.snapshot.params['UserId'] != 0) {
            this.UserId = this.route.snapshot.params['UserId'];
        }
        else {
            var role = JSON.parse(window.localStorage.getItem('currentUser'));
            this.UserId = role.UserId;
        }
        this.profiledataservice.GetUserExperience(this.UserId).subscribe(data => {
            this.experinceDetails = data;
        });

        this.profiledataservice.GetTeamMemberProfile(this.UserId)
			.subscribe((profile: any) => {
            this.profileDetails = profile;
            this.profileDetails.bloodGroup = this.bloodGroup.find(myObj => myObj.value == this.profileDetails.bloodGroup).label;
            this.profileDetails.zodiacSign = this.zodiacSign.find(myObj => myObj.value == this.profileDetails.zodiacSign).label
            console.log("----########",this.profileDetails);
            //this.profileDetails.bloodGroup = this.bloodGroup.find(myObj => myObj.value == 18).label;    
            //this.seedDataService.getLOVByID(this.profileDetails.bloodGroup).subscribe(lovname => {
            //    console.log(JSON.stringify(bloodGroup));
            //this.bloodGroup = lovname;
            //});
            });

        this.profiledataservice.Getdependent(this.UserId).subscribe(data => {
            this.dependentDetails = data;
            //console.log(this.dependentDetails);
            this.refdate = "?" + (new Date());
        });

        this.profiledataservice.GetSpecialization(this.UserId, '10th').subscribe(data => {
            this.Specialization1Oth = data;
            console.log("21212",this.Specialization1Oth);
            this.Specialization1Oth.passingYear = this.passingYear.find(myObj => myObj.value == this.Specialization1Oth.passingYear).label;
            //this.seedDataService.getLOVByID(this.Specialization1Oth.passingYear).subscribe(lovname => {
            //    this.Specialization1Oth.passingYear = lovname.name;
            //});
            
        });
        this.profiledataservice.GetSpecialization(this.UserId, '12th').subscribe(data => {
            this.Specialization12th = data;
            this.Specialization12th.passingYear = this.passingYear.find(myObj => myObj.value == this.Specialization12th.passingYear).label;
            //this.seedDataService.getLOVByID(this.Specialization12th.passingYear).subscribe(lovname => {                
            //    this.Specialization12th.passingYear = lovname.name;
            //});
        });
        this.profiledataservice.GetSpecialization(this.UserId, 'Gradution').subscribe(data => {
            this.SpecializationGradution = data;
            this.SpecializationGradution.passingYear = this.passingYear.find(myObj => myObj.value == this.SpecializationGradution.passingYear).label;
        });
        this.profiledataservice.GetSpecialization(this.UserId, 'PostGradution').subscribe(data => {
            this.SpecializationPostGradution = data;
            this.SpecializationPostGradution.passingYear = this.passingYear.find(myObj => myObj.value == this.SpecializationPostGradution.passingYear).label;
            //console.log("SpecializationPostGradution", this.SpecializationPostGradution);
        });
        }

    //ngOnInit() {
        
    //    this.seedDataService.getLOVByTypeName("BloodGroup").subscribe((bloodGroup: SelectItem[]) => {
    //        let data = this.renamePropertyNames(JSON.stringify(bloodGroup), "Select Blood Group");
    //        this.bloodGroup = data;
    //    });
    //    this.seedDataService.getLOVByTypeName("MaritalStatus").subscribe((maritalStatuslist: SelectItem[]) => {
    //        console.log("-----------", (maritalStatuslist));
    //    });
    //    this.seedDataService.getLOVByTypeName("ZodiacSigns").subscribe((zodiacSign: SelectItem[]) => {
    //        let data = this.renamePropertyNames(JSON.stringify(zodiacSign), "Select Zodiac Sign");
    //        this.zodiacSign = data;
    //    });
    //    this.seedDataService.getLOVByTypeName("Hobbies").subscribe((hobbieslist: SelectItem[]) => {

    //        let data = this.renamePropertyNames(JSON.stringify(hobbieslist), "Select Hobbies");

    //        this.hobbieslist = data;
    //    });
    //    this.seedDataService.getLOVByTypeName("PassingYear").subscribe((passingYear: SelectItem[]) => {
    //        let data = this.renamePropertyNames(JSON.stringify(passingYear), "Select Passing Year");
    //        this.passingYear = data;
    //    });

    //    if (this.route.snapshot.params['UserId'] != null && this.route.snapshot.params['UserId'] != 0) {
    //        this.UserId = this.route.snapshot.params['UserId'];
    //    }
    //    else {
    //        var role = JSON.parse(window.localStorage.getItem('currentUser'));
    //        this.UserId = role.UserId;
    //    }

    //    this.GetUserPhotoUrl(this.UserId);
    //    this.profiledataservice.GetTeamMemberProfile(this.UserId)
    //        .subscribe(profile => {
    //            this.profileDetails = profile;
    //            console.log(this.profileDetails);
    //            if (this.profileDetails != null && this.profileDetails.celebratedDateOfBirth != null && this.profileDetails.celebratedDateOfBirth != '') {
    //                this.DisableCelebratedDateOfBirth = true;
    //            }
    //            if (this.profileDetails != null && this.profileDetails.uanNumber != null && this.profileDetails.uanNumber != '') {
    //                this.DisableUAN = true;
    //            }
    //            if (this.profileDetails != null && this.profileDetails.esic != null && this.profileDetails.esic != '') {
    //                this.DisableESIC = true;
    //            }
    //            if (this.profileDetails != null && this.profileDetails.adharNumber != null && this.profileDetails.adharNumber != '') {
    //                this.DisableadharNumber = true;
    //            }
    //            if (this.profileDetails != null && this.profileDetails.anniversaryDate != null && this.profileDetails.anniversaryDate != '') {
    //                this.DisableAnniversaryDate = true;
    //            }
    //            this.seedDataService.getLOVByTypeName("MaritalStatus").subscribe((maritaStatusList) => {
    //                this.maritalStatusList = maritaStatusList;
    //                this.seedDataService.GetKeyValue("SingleMaritalStatus").subscribe((name) => {
    //                    this.SingleMaritalStatusName = name;
    //                    let tempStatusName = this.SingleMaritalStatusName;
    //                    let filteredList = this.maritalStatusList.filter(function (elem) {
    //                        return elem.name.trim().toUpperCase() == tempStatusName.trim().toUpperCase();
    //                    });
    //                    if (filteredList != null && filteredList.length > 0) {
    //                        this.SingleMaritalStatusID = filteredList[0].id;
    //                    }
    //                    if (this.SingleMaritalStatusID == this.profileDetails.maritalStatus ||
    //                        (this.profileDetails != null && this.profileDetails.anniversaryDate != null && this.profileDetails.anniversaryDate != '')) {
    //                        this.DisableAnniversaryDate = true;
    //                    }
    //                    else {
    //                        this.DisableAnniversaryDate = false;
    //                    }
    //                });
    //            });
    //            if (this.profileDetails.dateofJoining != null && this.profileDetails.dateofJoining != '') {
    //                this.maxDate = new Date(this.profileDetails.dateofJoining.toString());
    //            }
    //            else {
    //                this.maxDate = new Date();
    //            }
    //            this.minDate = new Date(1950, 1, 1);
    //        }
    //        );

    //    this.seedDataService.getLOVByTypeName("Location").subscribe((yearslist: SelectItem[]) => {
    //        let data = this.renamePropertyNames(JSON.stringify(yearslist), "Select Location");
    //        this.workLocation = data;
    //    });
    //    this.seedDataService.getLOVByTypeName("DependentRelationship").subscribe((dependentRelationships: SelectItem[]) => {
    //        let data = this.renamePropertyNames(JSON.stringify(dependentRelationships), "Select Relationship");
    //        this.dependentRelationships = data;
    //    });
    //    setTimeout(() => {
    //        if (this.route.snapshot.params['Id'] != null) {
    //            this.toggleEditDialog();
    //        }
    //    }, 1000);
    //}

	renamePropertyNames(json: any, _firstOption: any) {
        var obj = JSON.parse(json);

        if (obj != null && obj != undefined && obj != '') {
            var objddl = [];

            objddl.push({ 'label': _firstOption, 'value': '' })

            for (var i = 0; i < obj.length; i++) {

                if (obj[i].hasOwnProperty("name")) {
                    //objddl[i]["label"] = obj[i - 1]["name"];
                    //objddl[i]["value"] = obj[i - 1]["name"];
                    //delete obj[i - 1]["name"];
                    objddl.push({ 'label': obj[i]["name"], 'value': obj[i]["id"] });
                }
            }
        }
        return objddl;
    }

	GetRelation(id: any) {
        //alert(id);
        return (this.dependentRelationships.find(myObj => myObj.value == id).label)
    }
}

    


// WEBPACK FOOTER //
// ./src/app/Components/UserDetails/UserDetails.ts